import script from "./GolfCarAssetsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./GolfCarAssetsSection.vue?vue&type=script&lang=ts&setup=true"

import "./GolfCarAssetsSection.vue?vue&type=style&index=0&id=d685c746&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d685c746"]])

export default __exports__